import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Loader } from './../IconButton/Icons';

interface Props {
	label?: string | ReactElement | HTMLElement;
	onClick?: Function;
	disabled?: boolean;
	loading?: boolean;
	onlyLoader?: boolean;
	size?: 'small' | 'normal';
	variant?: 'filled' | 'outline' | 'text';
	background?: string;
	foreground?: string;
	fullWidth?: boolean;
	className?: string;
	style?: object;
	children?: ReactElement | HTMLElement | string;
	title?: string;
}

const ButtonHolder = styled.button`
	border: none;
	font-family: var(--fontFamily);
	&.filled:hover:not(.disabled-button):before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: { background: string; foreground: string }) => {
		return props.background + '1a';
	}};
		width: 100%;
		z-index: 1;
		height: 100%;
	}
	&:not(.filled):focus-visible {
		background-color: ${(props: { background: string; foreground: string }) => {
		return props.foreground + '33';
	}};
	}
	&:not(.filled):focus {
		background-color: ${(props: { background: string; foreground: string }) => {
		return props.foreground + '33';
	}};
	}

	&.filled:focus-visible {
		opacity: 0.8;
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.28);
	}
	&.filled:active:not(.disabled-button):before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: { background: string; foreground: string }) => {
		return props.background + '33';
	}};
		width: 100%;
		z-index: 1;
		height: 100%;
	}

	&.outline:hover:before,
	&.text:hover:before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: { background: string; foreground: string }) => {
		return props.foreground + '1a';
	}};
		width: 100%;
		z-index: 1;
		height: 100%;
	}

	&.outline:active:before,
	&.text:active:before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: { background: string; foreground: string }) => {
		return props.foreground + '33';
	}};
		width: 100%;
		z-index: 1;
		height: 100%;
	}
`;

const styleVars = getComputedStyle(document.querySelector(':root'));

export default function Button(props: Props) {
	// let background = props.background
	// 	? props.background
	// 	: styleVars.getPropertyValue('--btnFillColor') ||
	// 	  styleVars.getPropertyValue('--srvMsgBackground') ||
	// 	  '#383ff6';
	let background = props.background
		? props.background
		:
		styleVars.getPropertyPriority('--selectedColor')
	// ||
	// styleVars.getPropertyValue('--btnFillColor') ||
	// styleVars.getPropertyValue('--srvMsgBackground') ||
	// '#383ff6';

	let foreground = props.foreground
		? props.foreground
		: styleVars.getPropertyValue('--outlineBtnColor') ||
		styleVars.getPropertyValue('--srvMsgColor') ||
		'#ffffff';
	return (
		<ButtonHolder
			{...{ background: background, foreground: foreground }}
			className={`button-holder ${props.className} ${props.loading ? ' loading' : ''
				}  ${props.disabled ? 'disabled-button' : 'clickable'} ${props.variant ? props.variant : 'filled'
				} ${!props.size || props.size === 'normal'
					? 'normal button-text-1'
					: 'small button-text-2'
				} ${props.fullWidth ? 'full-width' : ''} nowrap  `}
			disabled={props.disabled}
			onClick={() => {
				if (!props.disabled && props.onClick) {
					props.onClick();
				}
			}}
			style={props.style}
		>
			{props.loading && props.onlyLoader ? (
				<Loader
					className='button-loader'
					fill={
						!props.variant || props.variant === 'filled'
							? background
							: foreground
					}
				/>
			) : (
				<>
					{props.loading ? (
						<Loader
							className='button-loader'
							fill={
								!props.variant || props.variant === 'filled'
									? background
									: foreground
							}
						/>
					) : null}

					{props.children ? (
						<div className='button-children'>{props.children}</div>
					) : null}
					{props.label ? props.label : null}
				</>
			)}
		</ButtonHolder>
	);
}
